// Drives the white progress line under the Hero and Road Hero banners. The
// line fills up like a stories-style timer; when it completes (or the arrow
// is clicked) it advances to the next background slide, for any section that
// has more than one [data-hero-slide] to cycle through.
//
// Timing is driven by a JS setTimeout, not the CSS animation's `animationend`
// — the fill animation is skipped under prefers-reduced-motion (see
// main.css), and relying on that event to drive auto-advance would silently
// stop the whole carousel for anyone with that preference on. The CSS
// animation is purely the visual; this timer is the source of truth.
const DURATION_MS = 6000;

export function initSlideTimers() {
  document.querySelectorAll('[data-slide-nav]').forEach(setupSlideTimer);
}

function setupSlideTimer(nav) {
  const fill = nav.querySelector('[data-slide-timer-fill]');
  const button = nav.querySelector('[data-slide-timer-next]');
  if (!fill || !button) return;

  const scope = nav.closest('[data-slideshow]') ?? nav;
  const slides = Array.from(scope.querySelectorAll('[data-hero-slide]'));
  // Each background slide has a matching text/CTA slide (same index) that
  // needs to cross-fade in step with it — see .hero-slide-content in main.css.
  const contentSlides = Array.from(scope.querySelectorAll('[data-hero-slide-content]'));
  let index = Math.max(slides.findIndex((slide) => slide.classList.contains('is-active')), 0);
  let timeoutId;
  let startedAt = 0;
  let remaining = DURATION_MS;

  function showSlide(nextIndex) {
    slides[index]?.classList.remove('is-active');
    contentSlides[index]?.classList.remove('is-active');
    contentSlides[index]?.setAttribute('aria-hidden', 'true');
    index = nextIndex;
    slides[index]?.classList.add('is-active');
    contentSlides[index]?.classList.add('is-active');
    contentSlides[index]?.removeAttribute('aria-hidden');
  }

  function schedule(ms) {
    window.clearTimeout(timeoutId);
    startedAt = Date.now();
    remaining = ms;
    timeoutId = window.setTimeout(advance, ms);
  }

  function restartBar() {
    fill.classList.remove('is-animating');
    // Force reflow so re-adding the class restarts the animation from 0%.
    void fill.offsetWidth;
    fill.classList.add('is-animating');
    schedule(DURATION_MS);
  }

  function advance() {
    if (slides.length > 1) showSlide((index + 1) % slides.length);
    restartBar();
  }

  function pause() {
    window.clearTimeout(timeoutId);
    remaining -= Date.now() - startedAt;
    fill.style.animationPlayState = 'paused';
  }

  function resume() {
    fill.style.animationPlayState = 'running';
    schedule(Math.max(remaining, 0));
  }

  button.addEventListener('click', advance);
  nav.addEventListener('mouseenter', pause);
  nav.addEventListener('mouseleave', resume);
  nav.addEventListener('focusin', pause);
  nav.addEventListener('focusout', resume);

  restartBar();
}
